import React from "react";
import PropTypes from "prop-types";
import OutlinedLink from "components/views/atoms/OutlinedLink";
import MoreHelp from "components/views/atoms/OutlinedLinkContent/MoreHelp";
import GA from "components/utils/GA";


const navigateHelpLink = (_lbl) => {
  GA.event({
    category: "homepage",
    action: "help_link",
    label: _lbl,
  });
  window.open(_lbl, '_blank');
}

const OutlinedMoreHelp = ({LinkLabel, className}) => {
  const classes = ["OutlinedMoreHelp"];

  if (className) classes.push(className);

  return (
    <OutlinedLink className={classes.join(" ")} onClick={() => navigateHelpLink(LinkLabel)}>
      <MoreHelp />
    </OutlinedLink>
  );
};

OutlinedMoreHelp.displayName = "OutlinedMoreHelp";

OutlinedMoreHelp.propTypes = {
  className: PropTypes.string,
  LinkLabel : PropTypes.string
};

OutlinedMoreHelp.defaultProps = {
  className: null,
  LinkLabel : ""
};

export default OutlinedMoreHelp;
